import React, { useState } from "react";
import { Eye, Pencil, Repeat2, Trash2, Ellipsis } from "lucide-react";
import DeletePopup from "./DeletePopup";
import DetailsPopup from "./DetailsPopup";
import UpdatePopup from "./UpdatePopup";
import "../../../Assets/Styles/NetflixList.css"

const ActionMenu = ({ row }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [typeEdit, setTypeEdit] = useState("");
    const [showDetailsPopup, setShowDetailsPopup] = useState(false);

    return (
        <div className="netflix-action-menu">
            <div
                className="netflix-action-icon-wrapper"
                onClick={() => setShowMenu(!showMenu)}
            >
                <Ellipsis className="netflix-action-icon" />
            </div>

            {showMenu && (
                <div className="netflix-action-dropdown">
                    <button
                        className="netflix-action-button netflix-action-details"
                        onClick={() => {
                            setShowDetailsPopup(true);
                            setShowMenu(false);
                        }}
                    >
                        <Eye className="netflix-action-icon" /> Détails
                    </button>
                    <button
                        className="netflix-action-button netflix-action-edit"
                        onClick={() => {
                            setShowEditPopup(true);
                            setShowMenu(false);
                        }}
                    >
                        <Pencil className="netflix-action-icon" /> Modifier
                    </button>
                    { row?.original?.userEmail && 
                        <button
                            className="netflix-action-button netflix-action-renewal"
                            onClick={() => {
                                setShowEditPopup(true);
                                setTypeEdit('Renewal')
                                setShowMenu(false);
                            }}
                        >
                            <Repeat2 className="netflix-action-icon" /> Renouveller
                        </button>
                    }
                    <button
                        className="netflix-action-button netflix-action-delete"
                        onClick={() => {
                            setShowDeletePopup(true);
                            setTypeEdit('Renewal')
                            setShowMenu(false);
                        }}
                    >
                        <Trash2 className="netflix-action-icon" /> Supprimer
                    </button>
                </div>
            )}

            {showDeletePopup && <DeletePopup row={row.original} onClose={() => setShowDeletePopup(false)} />}
            {showEditPopup && <UpdatePopup row={row.original} onClose={() => setShowEditPopup(false)} type={typeEdit} />}
            {showDetailsPopup && <DetailsPopup row={row.original} onClose={() => setShowDetailsPopup(false)} />}
        </div>
    );
};

export default ActionMenu;
